/*
 * @Date: 2021-02-02 17:38:03
 * @Description: Menu
 */
import { Menu } from '@babylon/design';

function renderMenu(h, item, i18n) {
    if (item.children && item.children.length > 0 && item.children.some((child) => !child.hidden)) {
        return renderSubmenu(h, item, i18n);
    } else {
        return renderMenuItem(h, item, i18n);
    }
}

function renderIcon(h, { icon = '' }) {
    if (icon && typeof icon === 'object' && icon !== null) {
        const isBIcon = icon.theme === 'custom';
        return isBIcon
            ? h('b-icon', {
                props: { name: icon.substr(2), width: 16, height: 16 },
                class: 'anticon anticon-menu'
            })
            : h('a-icon', { props: { type: icon.type,theme:icon.theme} });
    } else if(icon && icon.includes('svg')) { // 使用svg图片时
        return h('img', {
            style: {marginBottom: '3px',marginLeft: '-4px'},
            attrs: {src: icon}
        });
    }
    return '';
}
//没有子级
function renderMenuItem(h, item, i18n) {
    if (item.hidden) return null;

    const locale = `menu.${item.name}`;
    const icon = renderIcon(h, { icon: item.meta.icon });
    const text = h(
        'span',
        {
            attrs: {
                // style: 'width: 100%;display: inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'
                // style: ''
            }
        },
        i18n(locale)
    );
    return h('a-menu-item', { key: item.path }, [icon, text]);
}
//有子级
function renderSubmenu(h, item, i18n) {
    const icon = renderIcon(h, { icon: item.meta.icon });
    const children = item.children || [];
    const slotTitle = h('h4', { slot: 'title' }, [icon, h('span', i18n(`menu.${item.name}`))]);
    return h(
        'a-sub-menu',
        {
            key: item.path
        },
        [slotTitle, ...children.map((child) => renderMenu(h, child, i18n))]
    );
}

export default {
    name: 'menus',
    props: {
        menus: {
            type: Array,
            default: () => []
        }
    },
    inject: ['i18nRender'],
    mixins: [Menu],
    render(h) {
        const children = this.menus
            .map((item) => renderMenu(h, item, this.i18nRender))
            .filter(Boolean);
        this.$slots.default = children;
        return Menu.render.call(this, h);
    }
};
